import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="check-in-summary".
// Keeps the order's check-in summary (badge, progress bar, checked-in/remaining
// stats) in sync as individual ticket rows are checked in / undone. Ticket rows
// dispatch a "ticket-check-in:toggled" event (detail: { checkedIn }); we adjust
// the running count and re-render. Format strings come from data attributes so
// the displayed text stays i18n-driven.
export default class extends Controller {
  static targets = ["badge", "progressCount", "progressFill", "checkedInCount", "remainingCount"]
  static values = {
    total: Number,
    checkedIn: Number,
    fractionTemplate: String,
    countTemplate: String,
  }

  connect() {
    this._onToggle = (e) => this.onToggle(e)
    document.addEventListener("ticket-check-in:toggled", this._onToggle)
  }

  disconnect() {
    document.removeEventListener("ticket-check-in:toggled", this._onToggle)
  }

  onToggle(event) {
    const checkedIn = event.detail && event.detail.checkedIn
    this.checkedInValue = Math.min(this.totalValue, Math.max(0, this.checkedInValue + (checkedIn ? 1 : -1)))
    this.render()
  }

  render() {
    const ci = this.checkedInValue
    const total = this.totalValue
    const remaining = total - ci
    const pct = total > 0 ? Math.round((ci / total) * 100) : 0

    if (this.hasBadgeTarget) this.badgeTarget.textContent = this.fill(this.fractionTemplateValue, ci, total)
    if (this.hasProgressCountTarget) this.progressCountTarget.textContent = this.fill(this.countTemplateValue, ci, total)
    if (this.hasProgressFillTarget) this.progressFillTarget.style.width = `${pct}%`
    if (this.hasCheckedInCountTarget) this.checkedInCountTarget.textContent = ci
    if (this.hasRemainingCountTarget) this.remainingCountTarget.textContent = remaining
  }

  fill(template, checkedIn, total) {
    return (template || "")
      .replace("{checked_in}", checkedIn)
      .replace("{total}", total)
  }
}
